/**
 * @file     sellerPropertyTypes.ts
 * @purpose  Curated high-intent property types supported by the city-specific
 *           seller SEO family.
 */

export const SELLER_PROPERTY_TYPES = [
  {
    slug: 'detached',
    category: 'detached',
    singular: 'detached home',
    plural: 'detached homes',
  },
  {
    slug: 'condo',
    category: 'condo',
    singular: 'condo',
    plural: 'condos',
  },
  {
    slug: 'townhouse',
    category: 'townhouse',
    singular: 'townhouse',
    plural: 'townhouses',
  },
] as const;

export type SellerPropertyType = (typeof SELLER_PROPERTY_TYPES)[number];
export type SellerPropertyTypeSlug = SellerPropertyType['slug'];
export type SellerDwellingCategory = SellerPropertyType['category'];

export function getSellerPropertyType(slug: string): SellerPropertyType | null {
  return SELLER_PROPERTY_TYPES.find((type) => type.slug === slug) ?? null;
}

export function getSellerPropertyTypeByCategory(
  category: string,
): SellerPropertyType | null {
  return SELLER_PROPERTY_TYPES.find((type) => type.category === category) ?? null;
}
